import { forwardRef, type MouseEventHandler, memo, useCallback } from 'react';

import { ImageUpIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';
import { cn } from '@air/utils-tailwind';

export const SEARCH_COMMAND_VISUAL_SEARCH_TOOLTIP = 'Visual search';

export type SearchCommandVisualSearchButtonProps = {
  className?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  tooltip: string;
};

export const SearchCommandVisualSearchButton = memo(
  forwardRef<HTMLButtonElement, SearchCommandVisualSearchButtonProps>(({ className, onClick, tooltip }, ref) => {
    const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
      (event) => {
        // Nested inside SearchCommandTrigger's <button>; stop the trigger from opening the command.
        event.stopPropagation();
        onClick(event);
      },
      [onClick],
    );

    return (
      <Tooltip label={tooltip} side="bottom">
        <IconButton
          adsIcon
          appearance="ghost"
          className={cn('rounded-full p-0', className)}
          color="gray"
          data-testid="SEARCH_COMMAND_VISUAL_SEARCH_BUTTON"
          icon={ImageUpIcon}
          label={tooltip}
          onClick={handleClick}
          ref={ref}
        />
      </Tooltip>
    );
  }),
);

SearchCommandVisualSearchButton.displayName = 'SearchCommandVisualSearchButton';
